class Logger
  constructor: (debug = false, prefix = "", color = "#333", args...) ->
    return debug and console?.log?.bind?(console,
      "%c %c#{prefix}%c →"

      "background: #{color};
       border-radius: 10px;
       padding-left: 5px;
       font-size: xx-small;
       margin-right: 5px;"

      "color: #333;
       font-weight: bold;"

      ""

      args...
    ) or ->

module.exports = Logger
